/* ROTY recent purchases popup: real orders only, varied, no repeats.
   Data comes from <script id="RecentActivityData"> (see snippets/recent-activity.liquid).
   Rules: products with 3+ units in stock may repeat; products with 1-2 units show once per visit;
   countries alternate (Canada / USA) within a visit; same product or region is avoided back to back;
   every product has equal odds of being shown, however many orders it has. */
(function () {
  'use strict';

  var dataEl = document.getElementById('RecentActivityData');
  var box = document.querySelector('[data-ra]');
  if (!dataEl || !box) return;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  var entries = [];
  try { entries = JSON.parse(dataEl.textContent); } catch (err) { return; }

  var maxAge = (parseInt(dataEl.dataset.maxAge, 10) || 180) * 86400000;
  var perSession = parseInt(dataEl.dataset.perSession, 10) || 3;
  var delay = parseInt(dataEl.dataset.delay, 10) || 10000;
  var REPEAT_STOCK = 3;                   // products with this many units or more may show more than once
  var SHOWN_KEY = 'roty_recent_shown_v2'; // sessionStorage: what this visit has already seen
  var SEEN_KEY = 'roty_recent_seen_v2';   // localStorage: products shown on earlier visits
  var SEEN_MAX = 8;
  var CA_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT'];
  var now = Date.now();

  function where(e) {
    if (e.region) return e.region;
    if (!e.city) return '';
    var parts = String(e.city).split(',');
    return parts[parts.length - 1].trim() || e.city;
  }

  // "Cleveland, Ohio": the city from the "City, PR" text plus the full province or state name
  function place(e) {
    var parts = String(e.city || '').split(',');
    var city = parts.length > 1 ? parts.slice(0, -1).join(',').trim() : '';
    if (city && e.region) return city + ', ' + e.region;
    return e.city || e.region || '';
  }

  // Same buyer (masked name + city), so one person is not shown twice in a visit
  function personOf(e) { return e.name ? e.name + '|' + e.city : ''; }

  // 'CA' or 'US' from the "City, PR" text (Canadian province codes are Canada, anything else is USA)
  function countryOf(e) {
    if (e.country) return String(e.country).toUpperCase();
    var parts = String(e.city || '').split(',');
    var code = parts[parts.length - 1].trim().toUpperCase();
    return CA_PROVINCES.indexOf(code) !== -1 ? 'CA' : 'US';
  }

  function canRepeat(e) { return (e.stock || 0) >= REPEAT_STOCK; }

  // Orders inside the lookback window only
  entries = entries.filter(function (e) {
    var t = Date.parse(e.t);
    return t && now - t >= 0 && now - t <= maxAge;
  });

  // What this visit has shown so far
  var shown = [];
  try { shown = JSON.parse(sessionStorage.getItem(SHOWN_KEY) || '[]'); } catch (err) {}
  if (shown.length >= perSession) return;

  function shownHandle(h) {
    return shown.some(function (k) { return k.split('|')[0] === h; });
  }

  var byKey = {};
  entries.forEach(function (e) { byKey[e.handle + '|' + e.t] = e; });

  function shownPerson(e) {
    var p = personOf(e);
    return !!p && shown.some(function (k) { return byKey[k] && personOf(byKey[k]) === p; });
  }

  function available(e) {
    if (shownPerson(e)) return false;
    return canRepeat(e) ? shown.indexOf(e.handle + '|' + e.t) === -1 : !shownHandle(e.handle);
  }

  // Candidates: products with 3+ units keep every real order (they may repeat); products with
  // 1-2 units keep one random order per country, and only the first one shown is used.
  var groups = {};
  entries.forEach(function (e) {
    var key = canRepeat(e) ? e.handle + '|' + e.t : e.handle + '|' + countryOf(e);
    (groups[key] = groups[key] || []).push(e);
  });
  var pool = Object.keys(groups).map(function (k) {
    var list = groups[k];
    return list[Math.floor(Math.random() * list.length)];
  }).filter(available);
  if (!pool.length) return;

  // Products shown on earlier visits (kept in this browser) are slightly less likely to come first
  var seen = [];
  try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'); } catch (err) {}

  function busy() {
    var search = $('#SearchModal');
    return $('.drawer.is-open') || $('dialog[open]') || (search && !search.hidden) || document.body.classList.contains('ps-scroll-lock');
  }

  function ago(t) {
    var m = Math.round((now - Date.parse(t)) / 60000);
    if (m < 60) return 'within the last hour';
    var h = Math.round(m / 60);
    if (h < 24) return h + (h === 1 ? ' hour ago' : ' hours ago');
    var d = Math.round(h / 24);
    if (d < 7) return d + (d === 1 ? ' day ago' : ' days ago');
    var w = Math.round(d / 7);
    if (d < 60) return w + (w === 1 ? ' week ago' : ' weeks ago');
    var mo = Math.round(d / 30);
    return mo + ' months ago';
  }

  var lastRegion = '';
  var lastCountry = '';
  var lastHandle = '';
  var hideTimer;

  // Next notice: prefer the other country (Canada / USA), then a different product, then a
  // different region than the previous notice, then a product not shown on an earlier visit.
  // Among equally good candidates every product has the same odds (a product is chosen first,
  // then one of its real orders), so a product with many orders is not shown more often.
  function pick() {
    pool = pool.filter(available);
    if (!pool.length) return null;
    var bestScore = -1, best = [];
    pool.forEach(function (e) {
      var score = (countryOf(e) !== lastCountry ? 8 : 0) +
                  (e.handle !== lastHandle ? 4 : 0) +
                  (where(e) !== lastRegion ? 2 : 0) +
                  (seen.indexOf(e.handle) === -1 ? 1 : 0);
      if (score > bestScore) { bestScore = score; best = [e]; }
      else if (score === bestScore) { best.push(e); }
    });
    var handles = [];
    best.forEach(function (e) { if (handles.indexOf(e.handle) === -1) handles.push(e.handle); });
    var h = handles[Math.floor(Math.random() * handles.length)];
    var options = best.filter(function (e) { return e.handle === h; });
    var chosen = options[Math.floor(Math.random() * options.length)];
    pool.splice(pool.indexOf(chosen), 1);
    return chosen;
  }

  function remember(e) {
    shown.push(e.handle + '|' + e.t);
    try { sessionStorage.setItem(SHOWN_KEY, JSON.stringify(shown)); } catch (err) {}
    if (seen.indexOf(e.handle) !== -1) seen.splice(seen.indexOf(e.handle), 1);
    seen.push(e.handle);
    seen = seen.slice(-SEEN_MAX);
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch (err) {}
  }

  function show() {
    if (shown.length >= perSession || !pool.length) return;
    if (busy()) { setTimeout(show, 8000); return; }
    var e = pick();
    if (!e) return;
    lastRegion = where(e);
    lastCountry = countryOf(e);
    lastHandle = e.handle;
    $('[data-ra-link]', box).href = e.url;
    var img = $('[data-ra-img]', box);
    if (e.img) { img.src = e.img; img.hidden = false; } else { img.hidden = true; }
    $('[data-ra-where]', box).textContent = (e.name || 'Someone') + ' bought from ' + place(e);
    $('[data-ra-title]', box).textContent = e.title;
    $('[data-ra-when]', box).textContent = ago(e.t);
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-visible'); });
    remember(e);
    hideTimer = setTimeout(hide, 7000);
    if (shown.length < perSession && pool.length) setTimeout(show, 45000);
  }

  function hide() {
    clearTimeout(hideTimer);
    box.classList.remove('is-visible');
    setTimeout(function () { box.hidden = true; }, 300);
  }

  $('[data-ra-close]', box).addEventListener('click', function () {
    hide();
    shown = shown.concat(new Array(perSession).fill('x|x')); // stop for this visit
    try { sessionStorage.setItem(SHOWN_KEY, JSON.stringify(shown)); } catch (err) {}
  });

  setTimeout(show, delay);
})();
